/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@whitbread-eos/atoms/ui';
import { formatIBAssetsUrl, useTranslation, getQueryParams } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import { useState, useEffect } from 'react';
const SearchButton = ({ handleButtonClick, rooms, location, selectedDate, mobile = false, formLabels, dateFromUrl })=>{
    const { t } = useTranslation();
    const [dateForQueryParams, setDateForQueryParams] = useState();
    const queryParams = getQueryParams(dateForQueryParams, location, rooms);
    useEffect(()=>{
        if (!(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.from) || !(selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.to)) {
            setDateForQueryParams(dateFromUrl);
            return;
        }
        setDateForQueryParams(selectedDate);
    }, [
        selectedDate,
        dateFromUrl
    ]);
    return mobile ? /*#__PURE__*/ _jsx(Button, {
        "data-testid": "IB-Mobile-Search-Button",
        className: mobileSearchButton,
        onClick: ()=>handleButtonClick(queryParams),
        children: t('content.form.search')
    }) : /*#__PURE__*/ _jsx(Button, {
        className: desktopSearchButton,
        variant: "desktopSearchButton",
        size: "desktopSearchButton",
        "data-testid": "IB-Desktop-Search-Button",
        onClick: ()=>handleButtonClick(queryParams),
        children: /*#__PURE__*/ _jsx(Image, {
            className: searchIconStyle,
            src: formatIBAssetsUrl(formLabels === null || formLabels === void 0 ? void 0 : formLabels.searchIcon),
            width: 24,
            height: 24,
            alt: "Search Icon"
        })
    });
};
export default SearchButton;
const searchIconStyle = 'w-6 h-6';
const mobileSearchButton = 'mt-4';
const desktopSearchButton = 'flex justify-center items-center';
